import type { DatasetFileEditorProps } from "./dataset-file-editor.type";

import DatasetFileDownloadButton from "../dataset-file-download-button";
import DatasetFileUpload from "../dataset-file-upload";

const DatasetFileEditor = ({
  template,
  dataset,
  disabled,
}: DatasetFileEditorProps) => {
  if (!template) return null;

  if (dataset) {
    return <DatasetFileDownloadButton type="primary" dataset={dataset} />;
  }

  return <DatasetFileUpload template={template} disabled={disabled} />;
};

export default DatasetFileEditor;
